import axios from "axios";
import { Component } from "react";
import BaseWebService from "./base_web_service";
import AuthBloc from "../bloc/auth_bloc";
import DOMPurify from "dompurify";
import GeneralBloc from "../bloc/general_bloc";

export default class ProposalServices extends Component {

  static async getOccupationClass(occupationCode, NOBCode) {
    let header = await BaseWebService.standardHeaders();
    let url = DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/master?code=${NOBCode}&value=${occupationCode}&&category=OCC_NOB`);     

    let resp = await axios.get(
      url,
      { headers: header }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //viewProposalById
  static async viewProposalById(payload,role) {
    let header = await BaseWebService.standardHeaders();
    header.UserType=GeneralBloc.getCurrentRole();    
    let makerName= AuthBloc.getAgentName(); 
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/${role}/view_proposal?makerName=${makerName}`);
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //cancelProposalById for CAC and Supervisor flow
  static async cancelProposalById(payload,role) {
    let header = await BaseWebService.standardHeaders();
    header.UserType=GeneralBloc.getCurrentRole();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/${role}/cancelView_proposal`);
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //updateOtpMode
  //importProposalPersonalData for last step of quotation or first step of proposal flow 
  static async updateOtpMode(proposalId,notificationType, clientType) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/proposal/general?action=SWITCH&function=OTP_REQUEST_METHOD&notificationType=${notificationType}&clientType=${clientType}`);
    let resp = await axios.post(
      url,
      {
        proposalId:proposalId
      },
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //importProposalPersonalData for last step of quotation or first step of proposal flow 
  static async importProposalPersonalData(payload,validateToImport) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/proposal/importProposalPersonalData?validateToImport=${validateToImport}`);
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //deleteProposalById
  static async deleteProposalById(proposalId,quotationId) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/proposal/delete?proposalId=${proposalId}&quotationId=${quotationId}`);
    let resp = await axios.post(
      url,
      {},
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //getNobListing
  static async getNobListing(occupationCode) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/master/nob?occ=${occupationCode}`);
    let resp = await axios.get(
      url,
      { headers: header }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //getDeclarationQuestions
  static async getDeclarationQuestions(payload) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_CMS}/record/read/template?code=proposal_declarations`);
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //newProposal
  static async newProposal(payload,isImportData) {
    let header = await BaseWebService.standardHeaders();   
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/proposal/new?isImportData=${isImportData}`);
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //submitProposal for CAC flow
  static async submitProposal(proposalId) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/proposal/submit?proposalId=${proposalId}`);
    let resp = await axios.post(
      url,
      {},
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  static async saveAuthorizedPerson(proposalId,payload) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/proposal/authorizedPerson?proposalId=${proposalId}`);
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  static async getAuthorizedPerson(proposalId) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/proposal/authorizedPerson?proposalId=${proposalId}`);
    let resp = await axios.get(
      url,      
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  static async saveNominationBeneficiary(proposalId,payload) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/proposal/nominationBeneficiary?proposalId=${proposalId}`);
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  static async getNominationBeneficiary(proposalId) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/proposal/nominationBeneficiary?proposalId=${proposalId}`);
    let resp = await axios.get(
      url,      
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  

  static async saveCompanyDetails(proposalId,payload) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/proposal/companyDetail?proposalId=${proposalId}`);
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  static async getCompanyDetails(proposalId) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/proposal/companyDetail?proposalId=${proposalId}`);
    let resp = await axios.get(
      url,      
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }


  

  

  //saveFormProposal
  static async saveFormProposal(id, category, payload) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/proposal/proposal_attr?category=${category}&proposalId=${id}`);
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //getProposal details
  static async getProposal(id, category) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/proposal/proposal_attr?category=${category}&proposalId=${id}`);
    /* let category = payload["<category>"]; */
    let resp = await axios.get(
      url,
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //No use
  static async getProposalByQuotationId(payload) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL}/istudio/api/icms/v1/record/read/template?code=proposal_by_quotationid`);
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //getProposalDetail
  static async getProposalDetail(payload, userType, userId) {
    let header = await BaseWebService.standardHeaders();
    if(userType == "Client") {
      header.userType = userType
      header.userId = userId
    }
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/proposal/proposal_detail`);
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //getProposalSupervisorDetail for proposal detail in CAC and Supervisor flow
  static async getProposalSupervisorDetail(payload, userId) {
    let header = await BaseWebService.standardHeaders();
    header.userType = AuthBloc.getRoleDetails()
    header.userId =userId
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/proposal/proposal_detail`);
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
        
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //getHealthDeclarationForm
  static async getHealthDeclarationForm(productCode) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/formDeclaration?codeId=HEALTH_DECLARATION&productCode=${productCode}`);
    let resp = await axios.post(
      url,
      {},
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //getCustomerAcknowledgeDeclarationForm
  static async getCustomerAcknowledgeDeclarationForm() {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/acknowledge?codeId=CUSTOMER_ACKNOWLEDGE`);
    let resp = await axios.post(
      url,
      {},
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //emailProposal
  static async emailProposal(payload,type,clientType) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/proposal/email?type=${type}&clientType=${clientType}`);
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //generateDocuments
  static async generateDocuments(id) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/proposal/generate_proposalForm?proposalId=${id}`);
    let resp = await axios.post(
      url,
      {},
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //generateEntityForm
  static async generateEntityForm(id) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/proposal/entityForm?proposalId=${id}`);
    let resp = await axios.post(
      url,
      {},
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }
  

  //getProposalDoc
  static async getProposalDoc(id, userType, userId) {
    let header = await BaseWebService.standardHeaders();
    if(userType == "Client"){
      header.userType = userType;
      header.userId = userId;
    }
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/proposal/proposal_uploaded_documents?proposalId=${id}`);
    let resp = await axios.post(
      url,  
      {},    
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }
  
  //getNominationBeneficiaryForm
  static async getNominationBeneficiaryForm(id) {
    let header = await BaseWebService.standardHeaders();
    /* if(userType == "Client"){
      header.userType = userType;
      header.userId = userId;
    } */
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/proposal/nominationForm?proposalId=${id}`);
    let resp = await axios.get(
      url,        
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //getEntityForm
  static async getEntityForm(id) {
    let header = await BaseWebService.standardHeaders();
    /* if(userType == "Client"){
      header.userType = userType;
      header.userId = userId;
    } */
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/proposal/entityForm?proposalId=${id}`);
    let resp = await axios.get(
      url,        
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  static async getEMIDForm(id) {
    let header = await BaseWebService.standardHeaders();
    /* if(userType == "Client"){
      header.userType = userType;
      header.userId = userId;
    } */
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/proposal/midForm?proposalId=${id}`);
    let resp = await axios.get(
      url,        
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  
  static async getNominationBeneficiaryFormGenerate(id) {
    let header = await BaseWebService.standardHeaders();
    /* if(userType == "Client"){
      header.userType = userType;
      header.userId = userId;
    } */
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/proposal/nominationForm?proposalId=${id}`);
    let resp = await axios.post(
      url,  
      {},      
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }
  

  static async getEntityFormGenerate(id) {
    let header = await BaseWebService.standardHeaders();
    /* if(userType == "Client"){
      header.userType = userType;
      header.userId = userId;
    } */
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/proposal/entityForm?proposalId=${id}`);
    let resp = await axios.post(
      url,  
      {},      
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  static async getEMIDFormGenerate(id) {
    let header = await BaseWebService.standardHeaders();
    /* if(userType == "Client"){
      header.userType = userType;
      header.userId = userId;
    } */
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/proposal/midForm?proposalId=${id}`);
    let resp = await axios.post(
      url,  
      {},      
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //submitClientForReviewProposal
  static async submitClientForReviewProposal(proposalId,status) {
    let header = await BaseWebService.standardHeaders();
    header.userType=AuthBloc.getClientType();
    let makerName= AuthBloc.getAgentName();  
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/proposal/submitForReview?proposalId=${proposalId}&approval=${status}&makerName=${makerName}`);     
    let resp = await axios.post(
      url,
      {
        isSameAsInsuredMember:AuthBloc.getIsSameAsInsuredMember() == true || AuthBloc.getIsSameAsInsuredMember() == "true" ? "Yes": "No"
      },
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //submitForReviewProposal
  static async submitForReviewProposal(proposalId,status) {
    let header = await BaseWebService.standardHeaders();
    header.userType=AuthBloc.getRoleDetails();
    let makerName= AuthBloc.getAgentName();  
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/proposal/submitForReview?proposalId=${proposalId}&approval=${status}&makerName=${makerName}`);     
    let resp = await axios.post(
      url,
      {},
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //submitForReviewSuperviorProposal
  static async submitForReviewSuperviorProposal(proposalId,status,payload,userId) {
    let header = await BaseWebService.standardHeaders();
    header.userType=AuthBloc.getRoleDetails();
    header.userId =userId;
    let makerName= AuthBloc.getAgentName();    
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/proposal/submitForReview?proposalId=${proposalId}&approval=${status}&makerName=${makerName}`);         
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //submitProposalCAC
  static async submitProposalCAC(proposalId,userId) {
    let header = await BaseWebService.standardHeaders();
    header.userType=AuthBloc.getRoleDetails();    
    header.userId = AuthBloc.getAgentIdForSuperviorAndCAC().toString() 
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/proposal/submit?proposalId=${proposalId}`);     
    let resp = await axios.post(
      url,
      {},
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  

}
